import React, { Component } from "react";
import { connect } from "react-redux";
import "./style.css";
import "../../index.css";
class ActiveSuccess extends Component {
  render() {
    return (
      <div
        style={
          this.props.activeUI.showAciveSuccess === true
            ? { display: "block" }
            : { display: "none" }
        }
        className="active_success_box"
      >
        <div className="active_success_inline_box">
          <img alt="" src={require("../../images/my/active.png")}></img>
          <div className="active_success_txt">激活成功 已经可用</div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    activeUI: state.active.uiStateData,
  };
};

export default connect(mapStateToProps)(ActiveSuccess);



// WEBPACK FOOTER //
// ./src/components/ActiveSuccess/index.js